import { ActionIcon, Box, Menu, Text } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { IconLogout, IconSettings, IconSettingsCog, IconUser } from '@tabler/icons-react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import mainLogo from '../logo.png';
import { logoutUser } from '../store/authSlice';
import AccountDropdown from './AccountDropdown';
import AvatarInitials from './AvatarInitials';
import GetHelpButton from './ChatBot/GetHelpButton';
import OnboardingBookingButton from './OnboardingBookingButton';
import SuperAdminBadge from './SuperAdmin/SuperAdminBadge';
import useIsSuperAdmin from '../helpers/useIsSuperAdmin';

const AppNavbar = ({ guide, selectDomain }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { accountId, domainId } = useParams();
  const { user } = useSelector((state) => state.auth);
  const isSuperAdmin = useIsSuperAdmin();
  const isMobile = useMediaQuery('(max-width: 768px)');

  const accountDomainPage = (page) => {
    return '/accounts/' + accountId + '/domains/' + domainId + page;
  };

  const logout = (e) => {
    e.preventDefault();
    dispatch(logoutUser());
    selectDomain(null);
  };

  let guideDonePercent = 0;
  if (guide?.tabs) {
    const guideTasks = guide.tabs.map((tab) => tab.tasks).flat();
    const completedGuideTasks = guideTasks.filter((t) => !!t.isComplete).length;
    guideDonePercent = parseInt((completedGuideTasks / guideTasks.length) * 100);
  }

  const prefix = sessionStorage.getItem('prefix');

  return (
    <header className="app-navbar">
      <div className="navbar-content">
        {!isMobile && (
          <>
            <img src={mainLogo} alt="Releva" className="navbar-logo" data-tour="mainLogo" />
            <div className="navbar-divider" />
          </>
        )}
        <AccountDropdown selectDomain={selectDomain} />

        {prefix && (
          <Text span c="dimmed" ml="md">
            Environment: {prefix}
          </Text>
        )}

        {/* Spacer to push items to the right */}
        <div className="navbar-spacer" />

        {/* Right-aligned items */}
        <div className="navbar-right-items">
          <OnboardingBookingButton />

          <GetHelpButton
            guideDonePercent={guideDonePercent}
            onGuideClick={() => navigate(accountDomainPage('/guide'))}
          />

          <Box display="inline-block" id="domainDropdownButton" data-tour="userDropdown">
            <Menu position="bottom-end">
              <Menu.Target>
                <ActionIcon variant="filled" size="lg" radius="xl" aria-label="Settings">
                  <AvatarInitials user={user} />
                </ActionIcon>
              </Menu.Target>
              <Menu.Dropdown>
                <Menu.Label>
                  <div style={{ textAlign: 'center', paddingTop: 13 }}>
                    <span style={{ fontWeight: 'bold' }}>
                      {user.firstName} {user.lastName}
                    </span>
                    <br />
                    <span>{user.email}</span>
                  </div>
                </Menu.Label>
                <Menu.Divider />
                <Menu.Item
                  leftSection={<IconSettings size={16} />}
                  onClick={() => navigate(`/accounts/${accountId}/domains/${domainId}/settings/account`)}
                  data-tour="domainDropdownAccountSettings"
                >
                  Account
                </Menu.Item>
                <Menu.Divider />
                <Menu.Item
                  leftSection={<IconUser size={16} />}
                  onClick={() => navigate(accountDomainPage('/settings/user'))}
                >
                  Settings
                </Menu.Item>
                {isSuperAdmin && (
                  <Menu.Item
                    leftSection={<IconSettingsCog size={16} />}
                    rightSection={<SuperAdminBadge iconOnly show />}
                    onClick={() => navigate('/superAdmin')}
                  >
                    Super Admin Area
                  </Menu.Item>
                )}

                <Menu.Item leftSection={<IconLogout size={16} />} onClick={(e) => logout(e)}>
                  Sign Out
                </Menu.Item>
              </Menu.Dropdown>
            </Menu>
          </Box>
        </div>
      </div>
    </header>
  );
};
export default AppNavbar;
